// extracted by mini-css-extract-plugin
export var carousel = "carousel-module--carousel--38d00";
export var item = "carousel-module--item--41854";
export var items = "carousel-module--items--aafe0";